import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ButtonStyle } from '@libs/common/models';
import { NavItemModel } from '@libs/shared/models';
import { NavLinkDirective } from '@libs/shared/ui';

@Component({
  selector: 'ui-button-link',
  templateUrl: './button-link.component.html',
  styleUrls: ['../button/button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    NavLinkDirective,
  ],
})
export class ButtonLinkComponent {
  public link: InputSignal<NavItemModel> = input.required();
  public buttonStyle: InputSignal<ButtonStyle> = input<ButtonStyle>('filled');
}
